import React, { Component } from 'react'

import { localizer, changeLanguage } from './Translator'

import { Route, Redirect, Switch } from 'react-router'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { SnackbarCustom } from "./components/Utilities/SnackbarCustom";

import { Layout } from './components/Layout'
import { LoginLayout } from './components/login/LoginLayout'
import { SignupLayout } from './components/signup/SignupLayout'

import { OutboxLayout } from './components/outbox/OutboxLayout'
import { DraftsLayout } from './components/drafts/DraftsLayout'
import { ShipmentsLayout } from './components/shipments/ShipmentsLayout'
import { InboxLayout } from './components/inbox/InboxLayout'
import { UsersLayout } from './components/users/UsersLayout'
import { ReplacePassword } from './components/password/ReplacePassword'
import { ForgotPass } from './components/password/ForgotPass'
import { RecoverPass } from './components/password/RecoverPass'
import { SendInvitationsScreen } from './components/invite/SendInvitationsScreen'
import { ShipmentsSavedLayout } from './components/shipment-saved/ShipmentsSavedLayout'
import { InvitationsLayout } from './components/invite/InvitationsLayout'

import { PostalAddressLayout } from './components/postal-address/PostalAddressLayout'
import { EmailAddressLayout } from './components/email-address/EmailAddressLayout'
import { EmailAddressValidation } from './components/email-address/EmailAddressValidation'

import { BillingLayout } from './components/billing/BillingLayout'

import { DocsLayout } from './components/docs/api/DocsLayout'

import DateCustom from './components/Utilities/DateCustom'

import { Test } from './components/Test'
import { Grid } from '@material-ui/core'


const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0C373E",
    },
    secondary: {
       main: "#47D7AC99", /*#CDDE00*/
    }
  },
});

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props)
    this.state = {
      language: 'en',

      // Message displayed in case of password is close to expire
      expirationPasswordMessage: null,
      sessionExpiredOpen: false,
      sessionExpiredCallback: null
    }
    this.handleLanguageChange = this.handleLanguageChange.bind(this)
  }

  componentDidMount() {
    this.setUserLanguage()
    window.addEventListener('postamail:session-expired', this.handleSessionExpired)
  }

  componentWillUnmount() {
    window.removeEventListener('postamail:session-expired', this.handleSessionExpired)
  }

  /**
   * Establishes the language of the application based on the last used culture.
   * This action is required when the user directly navigates editing the browser's address line
   * instead of navigating using application's links.
   */
  async setUserLanguage() {
    var newLanguage = window.localStorage.getItem("culture")
    if (newLanguage === localizer.getLanguage()) return
    await changeLanguage(newLanguage)
    this.handleLanguageChange(newLanguage)
  }

  /**
   * To be called by components that may change the current application language.
   * Forcing the whole application to re-render.
   */
  handleLanguageChange(newLanguage) {
    this.setState({ language: newLanguage })
  }

  /**
   * Calculates if there are less than 15 days left to password expirates
   */
  handlePasswordExpirationDate = (expirationDate) => {
    let daysUntilExpiration = DateCustom.dateDiff(Date.now(), expirationDate, 'DAYS')
    let passwordmessage = daysUntilExpiration <= 15 ? localizer.ExpirationPasswordMessage + daysUntilExpiration + localizer.ExpirationPasswordDays : null

    this.setState({ expirationPasswordMessage: passwordmessage })
  }

  openConditionsURL() {
    var newLanguage = window.localStorage.getItem("culture")
    console.log("language", newLanguage)
    if (newLanguage === 'pt') {
      window.location.href = "https://mailcommsgroup.com/pt/aviso-legal/"
    } else if (newLanguage === 'en') {
      window.location.href = "https://mailcommsgroup.com/en/legal-notice/"
    } else {
      window.location.href = "https://mailcommsgroup.com/aviso-legal/"
    }


  }

  openPrivacyURL() {
    var newLanguage = window.localStorage.getItem("culture")
    if (newLanguage === 'pt') {
      window.location.href = "https://mailcommsgroup.com/pt/politica-de-privacidade/"
    } else if (newLanguage === 'en') {
      window.location.href = "https://mailcommsgroup.com/en/privacy-policy/"
    } else {
      window.location.href = "https://mailcommsgroup.com/aviso-legal/"
    }
  }

  openCookiesURL() {
    var newLanguage = window.localStorage.getItem("culture")
    if (newLanguage === 'pt') {
      window.location.href = "https://mailcommsgroup.com/pt/politica-de-cookies/"
    } else if (newLanguage === 'en') {
      window.location.href = "https://mailcommsgroup.com/en/cookie-policy/"
    } else {
      window.location.href = "https://mailcommsgroup.com/politica-de-cookies/"
    }
  }

  handleonClose = () => {
    this.setState({ expirationPasswordMessage: null })
  }

  handleSessionExpired = (event) => {
    this.setState({
      sessionExpiredOpen: true,
      sessionExpiredCallback: event.detail && event.detail.callback ? event.detail.callback : null
    })
  }

  getSessionExpiredCallback = () => {
    return this.state.sessionExpiredCallback
  }

  handleSessionExpiredAccept = () => {
    const callback = this.getSessionExpiredCallback()
    const callbackQuery = callback ? '?callback=' + encodeURIComponent(callback) : ''
    window.location.href = 'login' + callbackQuery
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <Layout>
          <Switch>
            <Redirect exact from="/" to="/login" />
            <Route path='/login' render={(props) => (<LoginLayout {...props} onLanguageChange={this.handleLanguageChange} handlePasswordExpirationDate={this.handlePasswordExpirationDate} />)} />
            <Route path='/signup' render={(props) => (<SignupLayout {...props} onLanguageChange={this.handleLanguageChange} />)} />
            <Route path='/replacepassword' render={(props) => (<ReplacePassword {...props} onLanguageChange={this.handleLanguageChange} />)} />
            <Route path='/forgotpass' render={(props) => (<ForgotPass {...props} onLanguageChange={this.handleLanguageChange} />)} />
            <Route path='/recoverpassword' render={(props) => (<RecoverPass {...props} onLanguageChange={this.handleLanguageChange} />)} />
            <Route path='/outbox' render={(props) => (<OutboxLayout {...props} />)} />
            <Route path='/saved' render={(props) => (<ShipmentsSavedLayout {...props} />)} />
            <Route path='/drafts' render={(props) => (<DraftsLayout {...props} />)} />
            <Route path='/shipment' render={(props) => (<ShipmentsLayout {...props} handlePasswordExpirationDate={this.handlePasswordExpirationDate} />)} />
            <Route path='/inbox' render={(props) => (<InboxLayout {...props} />)} />
            <Route path='/invite' render={(props) => (<SendInvitationsScreen {...props} />)} />
            <Route path='/invitations' render={(props) => (<InvitationsLayout {...props} />)} />
            <Route path='/users' render={(props) => (<UsersLayout {...props} />)} />
            <Route path='/postaladdress' render={(props) => (<PostalAddressLayout {...props} />)} />
            <Route path='/emailaddress' render={(props) => (<EmailAddressLayout {...props} />)} />
            <Route path='/user/email/validate' render={(props) => (<EmailAddressValidation {...props} />)} />
            <Route path='/billing' render={(props) => (<BillingLayout {...props} />)} />
            <Route path='/docs/api/:pageId?' render={(props) => (<DocsLayout {...props} />)} />
            {/*others routers*/}
            <Route path='/conditions' render={this.openConditionsURL} />
            <Route path='/privacy' render={this.openPrivacyURL} />
            <Route path='/cookies' render={this.openCookiesURL} />

            <Route path='/test' render={(props) => (<Test {...props} />)} />
          </Switch>
          
          {/* Password close to expire warning. */}
          <SnackbarCustom message={this.state.expirationPasswordMessage} severity="warning" handleonClose={this.handleonClose} />
          
         {/*  <Dialog open={this.state.sessionExpiredOpen} onClose={this.handleSessionExpiredAccept} aria-labelledby="session-expired-title">
            <DialogTitle id="session-expired-title">{localizer.SessionExpiredTitle}</DialogTitle>
            <DialogContent>
              <Typography>{localizer.SessionExpiredMessage}</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleSessionExpiredAccept} color="primary" autoFocus>{localizer.SessionExpiredAccept}</Button>
            </DialogActions>
          </Dialog> */}

          <Dialog
            open={this.state.sessionExpiredOpen}
            onClose={this.handleSessionExpiredAccept}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
          >
            <DialogTitle id="alert-dialog-title">
              <Typography className="typography-generic dialog-title">
                <i className="fa-solid fa-user-clock mr-5"></i>
                {localizer.SessionExpiredTitle}
              </Typography>
              <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleSessionExpiredAccept}></i>
            </DialogTitle>
            <DialogContent dividers={true} className="dialog-content">
              <Grid container item md={12}>
                <Typography className="typography-generic">{localizer.SessionExpiredMessage}</Typography>
              </Grid>
              <Grid container item md={12} className="mt-10" direction="row" spacing={2} justify="flex-end">
                <Button className="button-generic dialog-primary" variant="contained" onClick={this.handleSessionExpiredAccept}>{localizer.SessionExpiredAccept}</Button>
              </Grid>
            </DialogContent>
          </Dialog>
          
        </Layout>
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js